module.exports = __webpack_public_path__ + "img/highlights.5c4ba626.jpg";